import React from 'react';
import { Link } from 'react-router';
import withFeatureFlags from 'hocs/withFeatureFlags';
import { connect } from 'react-redux';
import styles from './style.css';

const AllSet = props => {
  const verifyEmailNotifFlag = props.enableVerifyEmailNotif;
  const kybNewContentFlag = props.kybNewContent;
  const isConfirmed = props.data.moka.user.is_confirmed;
  return (
    <div className={`row ${styles['row-center']}`}>
      {verifyEmailNotifFlag && (
        <div className="col-md-12">
          <img src="https://s3-ap-southeast-1.amazonaws.com/image.mokapos.com/growth/backoffice/kyb/all_set.png" />
          {!isConfirmed && <h2>Verify Your Email</h2>}
          {!isConfirmed && (
            <p>
              Thank you for filling in your details. To complete your sign up
              process, please click the verification link that we sent to{' '}
              <b>{props.data.moka.user.email}</b>
            </p>
          )}
          {!isConfirmed && (
            <Link
              to="/dashboard"
              className={`btn btn-primary btn-block ${styles.activate}`}
            >
              Start Selling with Moka POS
            </Link>
          )}
          {isConfirmed && <h2>You’re all set!</h2>}
          {isConfirmed && (
            <p>
              Thanks for filling in your details. You can now start selling thru
              Moka
            </p>
          )}
          {isConfirmed && (
            <Link
              to="/dashboard"
              className={`btn btn-primary btn-block ${styles.activate}`}
            >
              Start Selling
            </Link>
          )}
          <p className={`${styles['download-text']}`}>Download Moka POS</p>
          <ul className={`${styles['download-btn']}`}>
            <li>
              <a
                target="_blank"
                href="https://itunes.apple.com/us/app/moka-pos/id955811575"
              >
                <img
                  src="https://s3-ap-southeast-1.amazonaws.com/image.mokapos.com/growth/backoffice/kyb/apple.svg"
                  alt="ios"
                />
              </a>
            </li>
            <li>
              <a
                target="_blank"
                href="https://play.google.com/store/apps/details?id=com.mokapos.android"
              >
                <img
                  src="https://s3-ap-southeast-1.amazonaws.com/image.mokapos.com/growth/backoffice/kyb/google-play.svg"
                  alt="android"
                />
              </a>
            </li>
          </ul>
        </div>
      )}
      {!verifyEmailNotifFlag && (
        <div className="col-md-12">
          <img src="https://s3-ap-southeast-1.amazonaws.com/image.mokapos.com/growth/backoffice/kyb/all_set.png" />
          <h2>You’re all set!</h2>
          {kybNewContentFlag && (
            <p>
              Thanks for filling in your details. You can now start selling thru
              Moka
            </p>
          )}
          {!kybNewContentFlag && (
            <p>
              Thanks for filling in your details. We will notify you shortly
              about the status of your E-Wallet payment application through your
              email and Settings.
            </p>
          )}
          {kybNewContentFlag && (
            <Link
              to="/dashboard"
              className={`btn btn-primary btn-block ${styles.activate}`}
            >
              Start Selling
            </Link>
          )}
          {!kybNewContentFlag && (
            <Link
              to="/dashboard"
              className={`btn btn-primary btn-block ${styles.activate}`}
            >
              Start Selling with Moka POS
            </Link>
          )}
          <p className={`${styles['download-text']}`}>Download Moka POS</p>
          <ul className={`${styles['download-btn']}`}>
            <li>
              <a
                target="_blank"
                href="https://itunes.apple.com/us/app/moka-pos/id955811575"
              >
                <img
                  src="https://s3-ap-southeast-1.amazonaws.com/image.mokapos.com/growth/backoffice/kyb/apple.svg"
                  alt="ios"
                />
              </a>
            </li>
            <li>
              <a
                target="_blank"
                href="https://play.google.com/store/apps/details?id=com.mokapos.android"
              >
                <img
                  src="https://s3-ap-southeast-1.amazonaws.com/image.mokapos.com/growth/backoffice/kyb/google-play.svg"
                  alt="android"
                />
              </a>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

function select(state) {
  return {
    data: state,
  };
}

function mapFeatureFlags(flags) {
  return {
    kybNewContent: flags.kybNewContent,
    enableVerifyEmailNotif: flags.enableVerifyEmailNotification,
  };
}

export default withFeatureFlags(mapFeatureFlags)(connect(select)(AllSet));
